import React, { Fragment, useRef, useState, useEffect } from 'react';
import imgHeadphone from '../../assets/images/instantsupport-headphones.png';
import Topbar from './Topbar';
import { Helmet } from 'react-helmet';
import {
  errorToast,
  successToast,
  getPathForInstantSupport,
  informativeToast
} from '../../utils/helper';
import DashboardInfoCard from '../../component/common/DashboardInfoCard';
import InstantSupportTable from './InstantSupportTable';
import Pagination from '../../component/common/Pagination/Pagination';
import { Dialog, Transition } from '@headlessui/react';
import Table from '../../component/common/Table';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CompanyApi } from '../../api/companyApi';
import SearchInput from '../../component/common/Input/SearchInput';
import dummyAvatar from '../../assets/images/dummy-avatar.png';
import CommonPopover from '../../component/common/popover';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { set } from 'date-fns';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import LandingPage from './LandingPage';
import Loader from '../../component/common/Loader';
import Insights from './Insights';
import { Search } from 'lucide-react'; // Icon for search
import UpgradeDownArrow from '../../assets/images/upgrade-down-arrow.svg';
import InfoPopup from '../../component/common/InfoPopup';

const InstantSupportIndexPage = () => {
  const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedPerPage, setSelectedPerPage] = useState({ name: '10', value: 10 });
  const [addUsersOpen, setaddUsersOpen] = useState(false);
  const [updateUsersPlanOpen, setupdateUsersPlanOpen] = useState(false);
  const [upgradeUserPaymentDialogOpen, setupgradeUserPaymentDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // search query for add users
  const cancelButtonRef = useRef(null);
  const [theAddUsersList, settheAddUsersList] = useState([]);
  const [numberOfUsersForUpgradeUsers, setnumberOfUsersForUpgradeUsers] = useState(10);
  const [deactivateInstantSupportOpen, setdeactivateInstantSupportOpen] = useState(false);
  const [noticeToSwitchToCustomSupportOpen, setnoticeToSwitchToCustomSupportOpen] = useState(false);

  const [allocatedNumberForTheCompany, setallocatedNumberForTheCompany] = useState(0);
  const [supportStatusforTheCompany, setsupportStatusforTheCompany] = useState();
  const [planPurchaseDate, setplanPurchaseDate] = useState('');

  const [selectedPlan, setSelectedPlan] = useState(''); // 1 selectedPlan
  const [openPlan, setOpenPlan] = useState(''); // 2 same as selectedPlan
  const [employeeCount, setEmployeeCount] = useState(0); // 3 numberOfEmployees
  const [isAnnual, setIsAnnual] = useState(true); // 4 billingType
  const [typeOfPayment, settypeOfPayment] = useState();
  // insights useState
  const [companyTotaltSeatsInsights, setcompanyTotaltSeatsInsights] = useState(0);
  const [companyUsedSeatsInights, setcompanyUsedSeatsInights] = useState(0);

  const [companyHasInstantSupoortPlan, setcompanyHasInstantSupoortPlan] = useState(false);

  const [loader, setLoader] = useState(true);
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  //

  // const planNametoPrice = {
  //   telephonic: 15, // Telephonic EAP
  //   face: 24, // Face to Face & Video Services EAP
  //   rise: 48 // Shoorah RISE Plan
  // };

  const planNamesToPlanIDs = {
    telephonic: 'plan456',
    face: 'plan457',
    rise: 'plan458'
  };

  const planIDs = {
    0: 'telephonic', // Telephonic EAP
    1: 'face', // Face to Face & Video Services EAP
    2: 'rise' // Shoorah RISE Plan
  };

  const plans = {
    telephonic: {
      title: 'Telephonic EAP',
      price: 1.1,
      priceAnnually: 14.5,
      planRequirements: [
        '24/7, 365 telephone counselling and advice line',
        'Up to 6 structured counselling sessions per issue per year',
        'In-the-moment support between counselling sessions',
        'Personal financial/debt support through Auriga',
        'Legal advice through Irwin Mitchell',
        'Critical incident advice and telephone support',
        'Support for those with care responsibilities'
      ]
    },
    face: {
      title: 'Face to Face & Video Services EAP', // Face to Face & Video Services EAP
      price: 1.35,
      priceAnnually: 23.0,
      planRequirements: [
        'Includes all Telephonic EAP benefits',
        'Access to telephone, virtual, or face-to-face counselling',
        '10% discount on our B2B Premium plan'
      ]
    },
    rise: {
      title: 'Shoorah RISE Plan', // Shoorah RISE Plan
      price: 2.75,
      priceAnnually: 46.0,
      planRequirements: [
        'Includes all Face-to-Face & Video Services EAP benefits',
        'Enhanced psychological assessments, complex case support, CBT, and EMDR therapy',
        'Access to enhanced psychological assessments, complex case support and complex case management when deemed clinically appropriate. This includes CBT and EMDR therapy.',
        'Full case management for maximised clinical outcomes',
        '24/7, 365 health and wellbeing advice',
        'Online GP consultation services',
        'Full Premium access to our App and B2B suite'
      ]
    }
  };

  //

  const [selectedUsers, setSelectedUsers] = useState([]);

  const toggleUser = (index, id) => {
    setSelectedUsers((prevSelectedUsers) => {
      const exists = prevSelectedUsers.some((user) => user.userId === id);

      if (exists) {
        return prevSelectedUsers.filter((user) => user.userId !== id); // Remove if exists
      } else {
        return [...prevSelectedUsers, { userId: id }]; // Add if not exists
      }
    });
    console.log('Selected Users', selectedUsers);
  };

  useEffect(() => {
    CompanyApi.getInstantSupportAddUsersList(companyId).then((response) => {
      if (response?.data) {
        settheAddUsersList(response?.data?.data);
        //console.log('This data is for add users list', response?.data?.data);
      } else if (response?.code === 401) {
        errorToast('Something went wrong, please try again later !');
      }
    });
  }, [addUsersOpen, companyId]);

  useEffect(() => {
    // loading start

    //console.log('loading start', loader);
    setLoader(true);
    CompanyApi.getInstantSupportCompanyStatus(companyId)
      .then((response) => {
        if (response?.status === 200) {
          const {
            billingType,
            numberOfEmployees,
            selectedPlan,
            allocatedNumber,
            type,
            supportStatus,
            purchaseDate
          } = response?.data;

          console.log('response of company status ', response?.data);

          // Update all the states at once
          setallocatedNumberForTheCompany(allocatedNumber);
          setsupportStatusforTheCompany(supportStatus);
          setEmployeeCount(numberOfEmployees);
          setSelectedPlan(planIDs[selectedPlan]);
          setOpenPlan(planIDs[selectedPlan]);
          setIsAnnual(billingType === 'yearly' ? true : false);
          settypeOfPayment(type);
          setplanPurchaseDate(purchaseDate);

          setcompanyHasInstantSupoortPlan(true);
        }
      })
      .catch((error) => {
        console.error('Error fetching company status at index page:', error);
        setcompanyHasInstantSupoortPlan(false);
      })
      .finally(() => {
        // loading stop
        setLoader(false);
      });
    // /company/v1/instantSupport/insights?companyID=678f327a6e509d84980488c9
    CompanyApi.getInstantSupportInights(companyId).then((response) => {
      if (response?.status === 200) {
        console.log('these are the insights :', response?.data?.data);
        setcompanyTotaltSeatsInsights(response?.data?.data?.totalSeats);
        setcompanyUsedSeatsInights(response?.data?.data?.activeUsersCount);
      }
    });
  }, [companyId]);

  let isAdmin;
  isAdmin =
    userType === 0 || userType === 1 ? true : userType === 3 || userType === 4 ? false : true;

  const subAdminStatusCards = [
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M24.0972 16.8408H14.2051"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.5659 23.5684H24.458"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.8394 14.2061C15.7857 14.7329 14.7319 15.7866 14.2051 16.8403C14.7319 17.8941 15.7857 18.9478 16.8394 19.4747"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.8237 20.9346C22.8774 21.4614 23.9312 22.5152 24.458 23.5689C23.9312 24.6226 22.8774 25.6764 21.8237 26.2032"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M34.4046 21.0855C36.0211 19.677 38.3886 19.9295 39.6619 21.6545C39.8525 21.9127 40.0821 22.2147 40.3797 22.587C42.2681 24.9489 42.2681 28.369 40.3693 30.7226C38.9677 32.4601 37.498 34.2133 35.8552 35.8562C34.2125 37.499 32.4593 38.9685 30.7218 40.3703C28.3682 42.2689 24.9481 42.2689 22.5861 40.3807C22.1677 40.0462 21.8392 39.7985 21.5621 39.5961C19.8902 38.3749 19.6067 36.0875 20.9607 34.521C21.5771 33.808 22.2304 33.1166 22.8747 32.4383C23.7646 31.5014 25.2921 31.3972 26.267 32.2453C26.4382 32.3941 26.6557 32.5908 26.9566 32.8729C29.6584 31.2674 31.2958 29.61 32.872 26.9574C32.5848 26.6511 32.3859 26.4309 32.2357 26.258C31.3893 25.2836 31.4928 23.7606 32.4358 22.8793C33.081 22.2763 33.7351 21.6688 34.4046 21.0855Z"
            fill="#B6C0F3"
          />
          <path
            d="M34.4046 21.0855C36.0211 19.677 38.3886 19.9295 39.6619 21.6545C39.8525 21.9127 40.0821 22.2147 40.3797 22.587C42.2681 24.9489 42.2681 28.369 40.3693 30.7226C38.9677 32.4601 37.498 34.2133 35.8552 35.8562C34.2125 37.499 32.4593 38.9685 30.7218 40.3703C28.3682 42.2689 24.9481 42.2689 22.5861 40.3807C22.1677 40.0462 21.8392 39.7985 21.5621 39.5961C19.8902 38.3749 19.6067 36.0875 20.9607 34.521C21.5771 33.808 22.2304 33.1166 22.8747 32.4383C23.7646 31.5014 25.2921 31.3972 26.267 32.2453C26.4382 32.3941 26.6557 32.5908 26.9566 32.8729C29.6584 31.2674 31.2958 29.61 32.872 26.9574C32.5848 26.6511 32.3859 26.4309 32.2357 26.258C31.3893 25.2836 31.4928 23.7606 32.4358 22.8793C33.081 22.2763 33.7351 21.6688 34.4046 21.0855Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Total seats'}
      value={companyTotaltSeatsInsights}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M28.4744 40.866C36.9995 40.866 41.7948 36.0671 41.7948 27.536C41.7948 19.0048 36.9995 14.2061 28.4744 14.2061C19.9494 14.2061 15.154 19.0048 15.154 27.536C15.154 30.1404 15.601 32.397 16.4645 34.2754L14.2741 40.3034C13.9568 41.1767 14.7874 42.0305 15.6683 41.7368L21.9403 39.6446C23.7767 40.4498 25.9638 40.866 28.4744 40.866Z"
            fill="#B6C0F3"
          />
          <path
            d="M28.4744 40.866C36.9995 40.866 41.7948 36.0671 41.7948 27.536C41.7948 19.0048 36.9995 14.2061 28.4744 14.2061C19.9494 14.2061 15.154 19.0048 15.154 27.536C15.154 30.1404 15.601 32.397 16.4645 34.2754L14.2741 40.3034C13.9568 41.1767 14.7874 42.0305 15.6683 41.7368L21.9403 39.6446C23.7767 40.4498 25.9638 40.866 28.4744 40.866Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.055 22.3815C22.5206 21.8748 23.1299 21.5551 23.7835 21.4746C25.8193 21.2364 27.8199 21.2362 29.8557 21.4746C30.5092 21.5551 31.1185 21.8748 31.5842 22.3815C32.0498 22.8882 32.3444 23.5521 32.4198 24.2649C32.4312 24.375 32.4419 24.4849 32.4521 24.5946C33.0436 24.2524 33.6768 23.9349 34.3353 23.6702C35.202 23.3217 36.1562 23.738 36.4215 24.6336C36.6539 25.4171 36.8474 26.4356 36.8474 27.5963C36.8474 28.7569 36.6539 29.7755 36.4215 30.559C36.1562 31.4546 35.202 31.8708 34.3353 31.5224C33.677 31.2577 33.0439 30.9403 32.4526 30.5982C32.4425 30.7079 32.4319 30.8179 32.4208 30.9281C32.3453 31.6409 32.0508 32.3047 31.5851 32.8115C31.1194 33.3182 30.5102 33.6379 29.8566 33.7184C27.8204 33.9564 25.8197 33.9566 23.7835 33.7184C23.1299 33.6379 22.5206 33.3182 22.055 32.8115C21.5893 32.3047 21.2947 31.6409 21.2193 30.9281C20.988 28.68 20.9882 26.513 21.2193 24.2649C21.2947 23.5521 21.5893 22.8882 22.055 22.3815Z"
            fill="white"
          />
          <path
            d="M22.055 22.3815C22.5206 21.8748 23.1299 21.5551 23.7835 21.4746C25.8193 21.2364 27.8199 21.2362 29.8557 21.4746C30.5092 21.5551 31.1185 21.8748 31.5842 22.3815C32.0498 22.8882 32.3444 23.5521 32.4198 24.2649C32.4312 24.375 32.4419 24.4849 32.4521 24.5946C33.0436 24.2524 33.6768 23.9349 34.3353 23.6702C35.202 23.3217 36.1562 23.738 36.4215 24.6336C36.6539 25.4171 36.8474 26.4356 36.8474 27.5963C36.8474 28.7569 36.6539 29.7755 36.4215 30.559C36.1562 31.4546 35.202 31.8708 34.3353 31.5224C33.677 31.2577 33.0439 30.9403 32.4526 30.5982C32.4425 30.7079 32.4319 30.8179 32.4208 30.9281C32.3453 31.6409 32.0508 32.3047 31.5851 32.8115C31.1194 33.3182 30.5102 33.6379 29.8566 33.7184C27.8204 33.9564 25.8197 33.9566 23.7835 33.7184C23.1299 33.6379 22.5206 33.3182 22.055 32.8115C21.5893 32.3047 21.2947 31.6409 21.2193 30.9281C20.988 28.68 20.9882 26.513 21.2193 24.2649C21.2947 23.5521 21.5893 22.8882 22.055 22.3815Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Used Seats'}
      value={companyUsedSeatsInights}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M41.7948 27.7105C41.4348 26.2598 40.6148 24.9615 39.4535 24.0122C38.2151 23.0001 36.665 22.4473 35.0658 22.4473C33.4666 22.4473 31.9165 23.0001 30.6783 24.0122C30.4086 24.2326 30.1574 24.4718 29.926 24.7274C31.3567 24.987 32.7467 25.6032 33.8795 26.736C34.307 27.1635 34.6609 27.6275 34.9498 28.1165C37.2231 28.1213 39.4959 27.9859 41.7948 27.7105Z"
            fill="#B6C0F3"
          />
          <path
            d="M32.592 38.0972C33.7534 39.0465 34.5735 40.3449 34.9335 41.7955C34.9335 41.7955 30.8647 42.3259 28.2045 42.3259C25.5442 42.3259 21.4756 41.7955 21.4756 41.7955C21.8355 40.3449 22.6556 39.0465 23.8169 38.0972C25.0552 37.0853 26.6052 36.5322 28.2045 36.5322C29.8037 36.5322 31.3538 37.0853 32.592 38.0972Z"
            fill="#B6C0F3"
          />
          <path
            d="M28.2039 36.5327C30.8412 36.5327 32.3247 35.0492 32.3247 32.4119C32.3247 29.7745 30.8412 28.291 28.2039 28.291C25.5665 28.291 24.083 29.7745 24.083 32.4119C24.083 35.0492 25.5665 36.5327 28.2039 36.5327Z"
            fill="#B6C0F3"
          />
          <path
            d="M34.9335 41.7955C34.5735 40.3449 33.7534 39.0465 32.592 38.0972C31.3538 37.0851 29.8037 36.5322 28.2045 36.5322C26.6052 36.5322 25.0552 37.0851 23.8169 38.0972C22.6556 39.0465 21.8355 40.3449 21.4756 41.7955"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.2039 36.5327C30.8412 36.5327 32.3247 35.0492 32.3247 32.4119C32.3247 29.7745 30.8412 28.291 28.2039 28.291C25.5665 28.291 24.083 29.7745 24.083 32.4119C24.083 35.0492 25.5665 36.5327 28.2039 36.5327Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.0655 22.4478C37.7029 22.4478 39.1864 20.9643 39.1864 18.3269C39.1864 15.6896 37.7029 14.2061 35.0655 14.2061C32.4281 14.2061 30.9446 15.6896 30.9446 18.3269C30.9446 20.9643 32.4281 22.4478 35.0655 22.4478Z"
            fill="#B6C0F3"
          />
          <path
            d="M35.0655 22.4478C37.7029 22.4478 39.1864 20.9643 39.1864 18.3269C39.1864 15.6896 37.7029 14.2061 35.0655 14.2061C32.4281 14.2061 30.9446 15.6896 30.9446 18.3269C30.9446 20.9643 32.4281 22.4478 35.0655 22.4478Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M41.7946 27.7105C41.4347 26.2598 40.6146 24.9615 39.4533 24.0122C38.2152 23.0001 36.6651 22.4473 35.0657 22.4473C33.4665 22.4473 31.9165 23.0001 30.6782 24.0122"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M14.2053 27.7105C14.5653 26.2598 15.3853 24.9615 16.5467 24.0122C17.7849 23.0001 19.335 22.4473 20.9342 22.4473C22.5335 22.4473 24.0835 23.0001 25.3218 24.0122C25.5914 24.2326 25.8426 24.4718 26.074 24.7274C24.6433 24.987 23.2534 25.6032 22.1205 26.736C21.6931 27.1635 21.3392 27.6275 21.0503 28.1165C18.777 28.1213 16.5041 27.9859 14.2053 27.7105Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9346 22.4478C18.2972 22.4478 16.8137 20.9643 16.8137 18.3269C16.8137 15.6896 18.2972 14.2061 20.9346 14.2061C23.5719 14.2061 25.0554 15.6896 25.0554 18.3269C25.0554 20.9643 23.5719 22.4478 20.9346 22.4478Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9346 22.4478C18.2972 22.4478 16.8137 20.9643 16.8137 18.3269C16.8137 15.6896 18.2972 14.2061 20.9346 14.2061C23.5719 14.2061 25.0554 15.6896 25.0554 18.3269C25.0554 20.9643 23.5719 22.4478 20.9346 22.4478Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.2053 27.7105C14.5653 26.2598 15.3853 24.9615 16.5467 24.0122C17.7849 23.0001 19.335 22.4473 20.9342 22.4473C22.5334 22.4473 24.0835 23.0001 25.3218 24.0122"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Available Seats'}
      value={companyTotaltSeatsInsights - companyUsedSeatsInights}
    />
  ];

  const handleAddUsers = () => {
    console.log('here is the selected users', selectedUsers);
    const payloadForAddingUsers = {
      companyId: companyId,
      selectedUsers: selectedUsers
    };

    try {
      CompanyApi.postInstantSupportAddUsers(payloadForAddingUsers).then((response) => {
        if (response?.status === 200) {
          console.log('This is the response for postInstantSupportAddUsers', response);
        }
      });
    } catch (error) {
      console.log('This error is by fail to call AddUsers API', error);
    } finally {
      setSelectedUsers([]);
    }

    setaddUsersOpen(false);
  };

  const handleUpgradeUsers = () => {
    setLoader(true);
    const payloadForUpgradeUsers = {
      type: typeOfPayment,
      companyID: companyId,
      numberOfEmployees: parseInt(numberOfUsersForUpgradeUsers),
      upgradeType: 1
    };

    console.log('THIS IS THE PAYLOAD FOR upgrade users :', payloadForUpgradeUsers);

    CompanyApi.postUpdateUserAndInstantsupportPlan(payloadForUpgradeUsers)
      .then((response) => {
        if (response?.status === 200) {
          // const paymentLink = response?.data?.data?.paymentLink;
          // console.log('postInstantSupportUpgradeUsers paymentLink:', paymentLink);

          // if (paymentLink) {
          //   window.open(paymentLink, '_blank'); // Opens the payment link in a new tab
          // }
          if (response?.data?.meta?.code === 1) {
            console.log('Message from Upgrade Users API :', response?.data?.meta?.message);
            setLoader(false);
            successToast(response?.data?.meta?.message);
          }
          setupdateUsersPlanOpen(false);
          setupgradeUserPaymentDialogOpen(true);
        } else if (response?.status === 404) {
          setLoader(false);
          errorToast('Failed to upgrade users');
        }
      })
      .catch((error) => {
        console.log('This error is by fail to call postInstantSupportUpgradeUsers', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const deactivateInstantSupport = () => {
    const payLoadForDeactivateInstantSupport = {
      companyId: companyId,
      userId: '',
      status: 'InActive',
      toggle: true
    };
    CompanyApi.postInstnatSupportUserStatus(payLoadForDeactivateInstantSupport)
      .then(async (response) => {
        if (response?.status === 200) {
          console.log(
            'response from active-deactivate FOR TURNING OFF INSTANT SUPPORT API ',
            response
          );
        } else if (response?.status === 400) {
          console.log('Returning status 400 ERROR AT deactivateInstantSupport');
        }
      })
      .catch((error) => {
        console.log('Error At deactivateInstantSupport :', error);
      })
      .finally(() => {
        setdeactivateInstantSupportOpen(false);
      });
  };

  const filteredUsers = theAddUsersList.filter((member) =>
    member.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [componentKey, setComponentKey] = useState(0); // Key to force re-render

  const handleRefreshOfTable = async () => {
    //if (selectedUsers.length === 0) return;

    setLoader(true); // Show loader

    await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate an API call

    setComponentKey((prevKey) => prevKey + 1); // Change the key to force re-mount
    setLoader(false); // Hide loader
  };

  const [needsRefresh, setNeedsRefresh] = useState(false);

  // Function to trigger refresh across components

  useEffect(() => {
    console.log('Updated needsRefresh in parent:', needsRefresh);
  }, [needsRefresh]);

  const triggerRefresh = () => {
    setLoader(false);
    setNeedsRefresh(true);
  };

  // Function to acknowledge that refresh has completed
  const refreshCompleted = () => {
    setNeedsRefresh(false);
    setLoader(false);
  };
  const fetchInfo = async () => {
    if (userType === 4 || userType === 3) {
      try {
        const response = await CompanyApi.getInfoData('eap_b2b');
        if (response?.data?.meta?.code === 200) {
          if (response?.data?.data?.tutorialsData?.length > 0) {
            setOpen(true);
            setInfo(response?.data?.data);
          } else {
            setOpen(false);
            errorToast('Tutorial not found');
          }
        } else {
          setInfo(null);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          {companyHasInstantSupoortPlan ? (
            <>
              <div className="relative lg:pl-5 lg:mb-[45px]">
                <Helmet>
                  <meta charSet="utf-8" />
                  <title>B2B | Instant Support</title>
                </Helmet>
                <div className="mt-2 sm:mt-3"></div>
                <Topbar
                  title="Instant Support (EAP)"
                  infoBtn={true}
                  setOpen={setOpen}
                  fetchInfo={fetchInfo}
                />
                {loader && <Loader />}
              </div>

              <div className="relative lg:pl-5 lg:mb-[45px]">
                {/* <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 mt-5">
                  {subAdminStatusCards.map((item, index) => (
                    <React.Fragment key={index}>{item}</React.Fragment>
                  ))}
                </div> */}
                <Insights
                  key={needsRefresh}
                  needsRefresh={needsRefresh}
                  refreshCompleted={refreshCompleted}
                />

                <div className="xl:px-8 lg:px-6 px-4 py-[10px] sm:mt-6 mt-4  bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border border-gray-200 rounded-lg flex sm:justify-between justify-center mb-0 items-center">
                  <div className="hidden font-medium text-sm sm:flex">
                    <span>
                      Assigned Number {'  '} - {'  '}
                      <span className="text-[1.2rem] font-bold">
                        {supportStatusforTheCompany === 1
                          ? 'In Progress'
                          : supportStatusforTheCompany === 4
                          ? 'Disabled'
                          : allocatedNumberForTheCompany}
                      </span>
                    </span>
                  </div>

                  <div className="flex flex-row sm:flex-nowrap items-center gap-2">
                    <CommonPopover
                      label={
                        <>
                          <span className="flex items-center space-x-2">
                            Upgrade
                            <img className="ml-2" src={UpgradeDownArrow} alt="edit" />
                          </span>
                        </>
                      }
                      className="bg-shoorah-active text-shoorah-darkBg h-[32px] text-xs px-4 py-1.5 border-[1.5px] font-medium rounded-full flex items-center"
                      contentClassName="w-52 mt-1 p-2 flex flex-col items-center"
                    >
                      <ul className="text-sx w-36 pt-2 pb-2 space-y-1">
                        <li>
                          <button
                            className="text-base"
                            onClick={() => {
                              if (supportStatusforTheCompany === 1)
                                return informativeToast(
                                  'Your Instant Support plan is under review, you can add users once it is approved by Shoorah'
                                );
                              if (supportStatusforTheCompany === 4)
                                return informativeToast(
                                  'Your Instant Support plan is disabled, please contact Shoorah'
                                );
                              setaddUsersOpen(true);
                            }}
                          >
                            Add Users
                          </button>
                        </li>
                      </ul>
                      <ul className="text-base w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                        <li>
                          <button
                            className="text-base"
                            onClick={() =>
                              typeOfPayment === 1
                                ? navigate(getPathForInstantSupport('/instant-support/get-support'))
                                : navigate(
                                    getPathForInstantSupport('/instant-support/upgrade-plans')
                                  )
                            }
                          >
                            {typeOfPayment === 1 ? 'Purchase' : 'Upgrade'} Plan
                          </button>
                        </li>
                      </ul>
                      {typeOfPayment !== 1 && (
                        <ul className="text-base w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                          <li>
                            <button
                              className="text-base"
                              onClick={() => setupdateUsersPlanOpen(true)}
                            >
                              Upgrade Users
                            </button>
                          </li>
                        </ul>
                      )}
                    </CommonPopover>

                    {typeOfPayment !== 1 ? (
                      <>
                        <CommonPopover
                          label={
                            <>
                              {selectedTheme ? (
                                <>
                                  <svg
                                    className=""
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </>
                              ) : (
                                <>
                                  <svg
                                    className=""
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </>
                              )}
                            </>
                          }
                          className="h-[32px] text-xs px-4 py-1.5 border-none  font-medium flex items-center"
                          contentClassName="w-52 mt-1 p-2 flex flex-col items-center "
                        >
                          <ul className="text-base font-medium w-36 pt-2 pb-2 space-y-1">
                            <li>
                              <button
                                className="text-base font-medium"
                                onClick={() => {
                                  setnoticeToSwitchToCustomSupportOpen(true);
                                }}
                              >
                                Custom Number
                              </button>
                            </li>
                          </ul>
                          <ul className="text-base text-[#F93D40] font-medium w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                            <li>
                              <button
                                className="text-base"
                                onClick={() => setdeactivateInstantSupportOpen(true)}
                              >
                                Deactivate Feature
                              </button>
                            </li>
                          </ul>
                        </CommonPopover>
                      </>
                    ) : (
                      <>
                        <CommonPopover
                          label={
                            <>
                              <svg
                                className=""
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </>
                          }
                          className="h-[32px] text-xs px-4 py-1.5 border-none  font-medium flex items-center"
                          contentClassName="w-52 mt-1 p-2 flex flex-col items-center "
                        >
                          <ul className="text-base font-medium w-36 pt-2 pb-2 space-y-1">
                            <li>
                              <button
                                className="text-base font-medium"
                                onClick={() => {
                                  navigate(
                                    getPathForInstantSupport('/instant-support/add-custom-number')
                                  );
                                }}
                              >
                                Edit Number
                              </button>
                            </li>
                          </ul>
                          <ul className="text-base text-[#F93D40] font-medium w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                            <li>
                              <button
                                className="text-base "
                                onClick={() => setdeactivateInstantSupportOpen(true)}
                              >
                                Deactivate Feature
                              </button>
                            </li>
                          </ul>
                        </CommonPopover>
                      </>
                    )}
                  </div>
                </div>

                <InstantSupportTable
                  data={[]}
                  key={componentKey}
                  triggerRefresh={triggerRefresh}
                  setLoader={setLoader}
                />
              </div>
              <InfoPopup
                open={open}
                data={info}
                title="Instant Support"
                handleClose={() => setOpen(false)}
              />
            </>
          ) : (
            <>
              <LandingPage />
            </>
          )}
        </>
      )}

      {/* UI ends here  */}

      {/* Dialoge Box for Add Users  */}
      <Transition.Root appear show={addUsersOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left transition-all sm:my-8 sm:w-full sm:max-w-[692px]">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-gray-700 rounded-lg">
                    <div className="flex justify-between items-center mb-4">
                      <p className="text-xl font-normal">Add On</p>
                      <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={() => {
                          setaddUsersOpen(false);
                          setSelectedUsers([]);
                        }}
                      >
                        {' '}
                        {selectedTheme ? (
                          <>
                            <svg
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.2499 28.7495L28.7499 17.2495"
                                stroke="#F3F4F6"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.7499 28.7505L17.2499 17.2505"
                                stroke="#F3F4F6"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        ) : (
                          <>
                            <svg
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.2499 28.7495L28.7499 17.2495"
                                stroke="#1E2A3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.7499 28.7505L17.2499 17.2505"
                                stroke="#1E2A3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        )}
                      </button>
                    </div>

                    <div className="flex items-center w-full">
                      {/* Search Box */}
                      <div className="relative w-[518px]">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        <input
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="pl-10 w-full h-10 rounded-full bg-[#EEEEEE] text-[12px] text-gray-600 placeholder-gray-400 border-none outline-none focus:ring-2 focus:ring-gray-300"
                        />
                      </div>

                      {/* Done Button */}
                      <button
                        type="button"
                        className={`ml-4 px-6 py-2 text-sm font-medium text-white rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                          selectedUsers.length > 0
                            ? 'bg-[#4A57DA] hover:bg-[#3b47b5] focus:ring-[#4A57DA]'
                            : 'bg-gray-400 cursor-not-allowed'
                        }`}
                        onClick={() => {
                          if (selectedUsers.length > 0) handleAddUsers();
                          handleRefreshOfTable();
                        }}
                        disabled={selectedUsers.length === 0}
                      >
                        Done
                      </button>
                    </div>

                    <style jsx global>{`
                      /* Ultra-thin scrollbar styles */
                      .ultra-thin-scrollbar::-webkit-scrollbar {
                        width: 2px !important; /* Extra thin scrollbar */
                        height: 2px !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-track {
                        background: transparent !important;
                        margin: 0 !important;
                        border: none !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-thumb {
                        background: rgba(180, 180, 180, 0.5) !important;
                        border-radius: 2px !important;
                        border: none !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-thumb:hover {
                        background: rgba(150, 150, 150, 0.7) !important;
                      }

                      /* Completely hide scrollbar buttons */
                      .ultra-thin-scrollbar::-webkit-scrollbar-button {
                        display: none !important;
                        width: 0 !important;
                        height: 0 !important;
                        background: transparent !important;
                        border: none !important;
                      }

                      /* Firefox scrollbar */
                      .ultra-thin-scrollbar {
                        scrollbar-width: thin !important;
                        scrollbar-color: rgba(180, 180, 180, 0.5) transparent !important;
                      }

                      /* Hide up/down buttons in Firefox */
                      .ultra-thin-scrollbar * {
                        scrollbar-width: thin !important;
                      }

                      /* Container for the scrollable content */
                      .scroll-container {
                        margin: 0 -6px 0 0 !important;
                        padding: 0 6px 0 0 !important;
                        max-height: 80vh !important;
                        overflow-y: auto !important;
                      }
                    `}</style>

                    <div className="scroll-container ultra-thin-scrollbar">
                      <div className="space-y-3 max-h-80">
                        <ul className="divide-y divide-gray-200 mt-3">
                          {filteredUsers.map((member, index) => (
                            <li
                              key={member._id || index}
                              className="py-4 flex items-center cursor-pointer gap-3 hover:bg-gray-100 px-3 rounded-none transition group"
                              onClick={() => toggleUser(index, member._id)}
                            >
                              <input
                                type="radio"
                                checked={selectedUsers.some((user) => user.userId === member._id)}
                                readOnly
                                className="form-checkbox h-5 w-5 text-shoorah-primary border-gray-300 rounded focus:shadow-shoorah-primary cursor-pointer"
                              />

                              <div className="flex-shrink-0 h-10 w-10">
                                <img
                                  className="h-10 w-10 rounded-full object-cover"
                                  src={member.image || dummyAvatar}
                                  alt={member.name}
                                />
                              </div>

                              <div className="ml-1">
                                <h3 className="text-xl font-medium dark:text-gray-200 text-[#1E2A3B] group-hover:text-black">
                                  {member.name
                                    ? member.name
                                        .split(' ')
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(' ')
                                    : ''}
                                </h3>
                                <p className="text-base font-normal dark:text-gray-200 text-[#0C1218] group-hover:text-black">
                                  {member.job_role
                                    ? member.job_role
                                        .split(' ')
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(' ')
                                    : ''}
                                </p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge Box for Update users  */}
      <Transition.Root appear show={updateUsersPlanOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-gray-700 rounded-lg">
                    <div className="flex justify-between items-center mb-4">
                      <p className="text-xl text-[#0B1D2E] dark:text-shoorah-bodyBackground font-semibold">
                        Purchase Details
                      </p>
                      <button
                        className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
                        onClick={() => setupdateUsersPlanOpen(false)}
                      >
                        <svg
                          width="46"
                          height="46"
                          viewBox="0 0 46 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="stroke-current"
                        >
                          <path
                            d="M17.25 28.75L28.75 17.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M28.75 28.75L17.25 17.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="flex flex-col w-full max-w-4xl mt-0 bg-white dark:bg-gray-800 my-5">
                      {typeOfPayment === 1 ? (
                        <>
                          <div className="w-full sm:w-full lg:w-full mr-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700 flex justify-between items-center">
                              <div className="text-gray-700 dark:text-gray-300 font-medium text-sm sm:text-base">
                                {typeOfPayment === 1 ? 'View Plans' : 'Current Plan'}
                              </div>
                              <div className="inline-flex px-1 sm:px-2 h-8 items-center justify-center border border-gray-300 rounded-md bg-white dark:bg-shoorah-darkGray text-black dark:text-white text-sm sm:h-6 sm:text-sm md:h-8 md:text-base">
                                {employeeCount === 99999 ? 'N/A' : employeeCount}
                              </div>
                            </div>

                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['telephonic']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['telephonic']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['telephonic']?.priceAnnually
                                      : plans['telephonic']?.price.toFixed(2)}
                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['face']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['face']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['face']?.priceAnnually
                                      : plans['face']?.price.toFixed(2)}

                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['rise']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['rise']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['rise']?.priceAnnually
                                      : plans['rise']?.price.toFixed(2)}

                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="w-full sm:w-full lg:w-full mr-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700 flex justify-between items-center">
                              <div className="text-gray-700 dark:text-gray-300 font-medium text-sm sm:text-base">
                                Current plan
                              </div>
                              <div className="w-12 h-8 flex items-center justify-center border border-gray-300 rounded-md bg-white dark:bg-shoorah-darkGray text-black dark:text-white text-sm sm:w-10 sm:h-6 sm:text-sm md:w-12 md:h-8 md:text-base">
                                {employeeCount}
                              </div>
                            </div>

                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans[selectedPlan]?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans[selectedPlan]?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans[selectedPlan]?.priceAnnually
                                      : plans[selectedPlan]?.price.toFixed(2)}
                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-gray-700 flex justify-between items-center">
                          <div className="text-black dark:text-gray-300 font-medium text-base">
                            Add Users:
                          </div>
                        </div>
                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-gray-700 flex justify-between items-center">
                          <div className="text-gray-700 dark:text-gray-300 font-medium text-xs">
                            How many employees do you wish to add to this plan?
                          </div>

                          <input
                            type="number"
                            className="w-16 h-9 p-2 border text-sm font-medium border-gray-300 dark:border-gray-600 rounded-lg text-black dark:text-gray-200 bg-white dark:bg-gray-800 text-center placeholder:text-gray-500"
                            value={numberOfUsersForUpgradeUsers}
                            onChange={(e) => {
                              setnumberOfUsersForUpgradeUsers(e.target.value);
                            }}
                            placeholder="10"
                          />
                        </div>

                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-gray-700 flex justify-between items-center">
                          <div className="text-gray-700 dark:text-gray-300 font-medium text-xs">
                            Plan purchased date
                          </div>
                          <span className="text-sm text-gray-900 font-medium dark:text-gray-400">
                            {planPurchaseDate
                              ? new Date(planPurchaseDate).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                })
                              : '-'}
                          </span>
                        </div>
                      </div>

                      <button
                        onClick={() => {
                          handleUpgradeUsers();
                        }}
                        className={`w-full sm:w-fit px-6 py-2 mt-8 text-base font-normal rounded-full border shadow-sm bg-shoorah-active text-shoorah-darkBg`}
                      >
                        Increase employees range
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge for deactivate feature */}
      <Transition.Root appear show={deactivateInstantSupportOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left transition-all sm:my-8 sm:w-full sm:max-w-[512px]">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-gray-700 rounded-lg">
                    {/* <div className="flex justify-between items-center mb-4">
                      <p className="text-xl font-normal">Add On</p>
                      
                    </div> */}
                    <center>
                      <div className="font-normal text-base">
                        Are you sure you want to turn off the Instant Support (EAP) feature, you can
                        always turn it back on when needed.
                      </div>
                    </center>

                    <div className="flex items-center justify-center w-full">
                      <button
                        onClick={() => {
                          setdeactivateInstantSupportOpen(false);
                        }}
                        className="w-full mx-1 sm:w-[140px] p-2 mt-8 text-sm font-normal rounded-full text-black border border-black bg-white"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={() => {
                          deactivateInstantSupport();
                          console.log('start');
                          handleRefreshOfTable();
                          console.log('start x2');
                        }}
                        className="w-full mx-1 sm:w-[140px] p-2 mt-8 text-sm font-normal rounded-full border shadow-sm bg-[#F93D40] dark:bg-[#F93D40] text-shoorah-darkBg"
                      >
                        Deactivate
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge for Success when Users get Upgraded */}
      <Transition.Root show={upgradeUserPaymentDialogOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setupgradeUserPaymentDialogOpen}
        >
          {/* Disable interactions with the background when modal is open */}
          <div
            className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity"
            inert={upgradeUserPaymentDialogOpen ? 'true' : undefined}
          />

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-none p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                  <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                    <Dialog.Title
                      as="h3"
                      className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                    >
                      <img
                        src={instantSupportDialogIcon}
                        alt="DropdownIcon"
                        className="dark:invert mx-auto"
                      />
                    </Dialog.Title>
                  </div>
                  <div>
                    <p className="text-lg text-gray-700 dark:text-gray-300">
                      The number of users in your current Instant Support (EAP) plan has increased.
                      Sent for approval, will notify soon
                    </p>
                    <Link
                      className="w-[173px] h-[40px] bg-[#4A56DB] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer shadow-sm flex items-center justify-center mx-auto mt-6"
                      onClick={() => {
                        setupgradeUserPaymentDialogOpen(false);
                        setTimeout(() => {
                          navigate(getPathForInstantSupport('/instant-support'));
                        }, 100);
                      }}
                    >
                      Got It
                    </Link>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* dialoge Box for warning/ notice message for B2B to switch to custom plan  */}
      <Transition.Root show={noticeToSwitchToCustomSupportOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setnoticeToSwitchToCustomSupportOpen}
        >
          {/* Disable interactions with the background when modal is open */}
          <div
            className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity"
            inert={noticeToSwitchToCustomSupportOpen ? 'true' : undefined}
          />

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-none p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                  <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                    <Dialog.Title
                      as="h3"
                      className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                    >
                      <img
                        src={instantSupportDialogIcon}
                        alt="DropdownIcon"
                        className="dark:invert mx-auto"
                      />
                    </Dialog.Title>
                  </div>
                  <div>
                    <p className="text-lg text-gray-700 dark:text-gray-300">
                      Are you sure you want to switch to the Custom Plan? Your current Shoorah
                      Instant Support plan will be deactivated, and the Custom Plan will begin. We
                      appreciate your decision. Thank you!
                    </p>
                    <div className="flex justify-center items-center gap-x-4 mt-6">
                      <Link
                        className="flex-grow max-w-[173px] h-[40px] bg-[#4A56DB] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                          setnoticeToSwitchToCustomSupportOpen(false);
                          setTimeout(() => {
                            navigate(
                              getPathForInstantSupport('/instant-support/add-custom-number')
                            );
                          }, 100);
                        }}
                      >
                        Yes, am sure
                      </Link>
                      <Link
                        className="flex-grow max-w-[173px] h-[40px] bg-white text-[#4A56DB] text-lg font-normal rounded-full border border-gray-300 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                          setnoticeToSwitchToCustomSupportOpen(false);
                        }}
                      >
                        No
                      </Link>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
export default InstantSupportIndexPage;
